"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingEventSync = exports.useTrackingEventSync = exports.sendEventToTagManager = exports.TaskTrackingStepsComplete = void 0;
const js_sha256_1 = require("js-sha256");
const react_1 = __importDefault(require("react"));
const react_gtm_module_1 = __importDefault(require("react-gtm-module"));
const react_redux_1 = require("react-redux");
const merlin_hooks_1 = require("@travelnest/merlin-hooks");
const __1 = require("..");
const TaskCompletenessContext_1 = require("../context/TaskCompletenessContext");
const types_1 = require("../types");
const capability_1 = require("../util/capability");
const helpers_1 = require("../view/pages/dashboard/helpers");
const SummaryTile_1 = require("../view/pages/dashboard/SummaryTile");
const types_2 = require("../entities/fact/types");
const capacity_1 = require("../view/pages/tasks/bedrooms/capacity");
const data_1 = require("../view/pages/tasks/bedrooms/data");
var TaskTrackingStepsComplete;
(function (TaskTrackingStepsComplete) {
    TaskTrackingStepsComplete["THIRTEEN"] = "tbf_13_parts_complete";
    TaskTrackingStepsComplete["FIFTEEN"] = "tbf_15_parts_complete";
    TaskTrackingStepsComplete["EIGHTEEN"] = "tbf_18_parts_complete";
    TaskTrackingStepsComplete["ALL"] = "tbf_all_parts_complete";
})(TaskTrackingStepsComplete = exports.TaskTrackingStepsComplete || (exports.TaskTrackingStepsComplete = {}));
const sendEventToTagManager = (email, event, data) => {
    const dataLayer = Object.assign({ user_email_sha256_hash: (0, js_sha256_1.sha256)(email || ''), event }, (data || {}));
    react_gtm_module_1.default.dataLayer({ dataLayer });
};
exports.sendEventToTagManager = sendEventToTagManager;
// Send specific data to tag manager when a task is completed relating to ICP attributes
const getIcpAttributes = (customerId, propertyId, taskState, entityState) => {
    var _a, _b, _c;
    const completedStates = [types_2.TaskCompletionState.COMPLETE, types_2.TaskCompletionState.REVIEW_REQUIRED];
    if (!completedStates.includes(taskState.CHANNEL_SELECTION.completion))
        return;
    if (!completedStates.includes(taskState.BEDROOMS.completion))
        return;
    if (!completedStates.includes(taskState.LOCATION.completion))
        return;
    const selectedChannels = (_a = entityState.data.listingContracts.byCustomerId[customerId]) === null || _a === void 0 ? void 0 : _a.filter((c) => c.list_property);
    const property = entityState.data.properties.byId[propertyId];
    return {
        selected_channel_count: (_b = selectedChannels === null || selectedChannels === void 0 ? void 0 : selectedChannels.length) !== null && _b !== void 0 ? _b : 0,
        country_code: property === null || property === void 0 ? void 0 : property.country_code,
        guests: (0, capacity_1.estimateCapacity)((0, data_1.bedsToEditState)((property === null || property === void 0 ? void 0 : property.beds) || []), (_c = entityState.data.itemTypes) === null || _c === void 0 ? void 0 : _c.bed_types)
    };
};
const useTrackingEventSync = () => {
    const { state: taskState } = react_1.default.useContext(TaskCompletenessContext_1.TaskCompletenessContext);
    const { capabilities, customerId, propertyId } = react_1.default.useContext(__1.AppContext);
    const entityState = (0, react_redux_1.useSelector)((state) => state);
    const completionSummary = (0, SummaryTile_1.tasksPerCompletionState)((0, helpers_1.filterCompletenessByCapabilities)(taskState, capabilities));
    const totalComplete = completionSummary.complete.length;
    const allComplete = completionSummary.needInput.length === 0 && completionSummary.needReview.length === 0;
    const email = (0, react_redux_1.useSelector)((state) => { var _a, _b; return (_b = (_a = state.data.customers.byId[customerId]) === null || _a === void 0 ? void 0 : _a.email) !== null && _b !== void 0 ? _b : 'testing'; });
    const previousTotalComplete = (0, merlin_hooks_1.usePrevious)(totalComplete);
    const shouldRecordEvents = (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.RecordTaskCompleteTrackingEvents);
    react_1.default.useEffect(() => {
        if (shouldRecordEvents) {
            const icpLayer = getIcpAttributes(customerId, propertyId, taskState, entityState);
            if (icpLayer)
                (0, exports.sendEventToTagManager)(email, 'onboarding_icp_attributes', icpLayer);
            if (allComplete) {
                (0, exports.sendEventToTagManager)(email, TaskTrackingStepsComplete.ALL);
            }
            else if (totalComplete > previousTotalComplete) {
                switch (totalComplete) {
                    case 13:
                        (0, exports.sendEventToTagManager)(email, TaskTrackingStepsComplete.THIRTEEN);
                        break;
                    case 15:
                        (0, exports.sendEventToTagManager)(email, TaskTrackingStepsComplete.FIFTEEN);
                        break;
                    case 18:
                        (0, exports.sendEventToTagManager)(email, TaskTrackingStepsComplete.EIGHTEEN);
                        break;
                    default:
                        break;
                }
            }
        }
    }, [totalComplete, previousTotalComplete]);
};
exports.useTrackingEventSync = useTrackingEventSync;
const TrackingEventSync = (props) => {
    (0, exports.useTrackingEventSync)();
    return null;
};
exports.TrackingEventSync = TrackingEventSync;
//# sourceMappingURL=index.js.map